import * as constant from "../constants/Constant";

const initialState = {
  workshops: [],
  selectedWorkshop: null,
  communityLinks: [],
  communityLinksPagination: null,
  loading: false,
  error: null,
};

export const WorkshopReducer = (state = initialState, action) => {
  switch (action.type) {
    case constant.GET_ALL_WORKSHOPS:
      return {
        ...state,
        workshops: action.payload.data?.result || action.payload.workshops || action.payload.data || action.payload || [],
        pagination: action.payload.data?.pagination || null,
        loading: false,
        error: null,
      };
    case constant.GET_WORKSHOP_BY_ID:
      return {
        ...state,
        selectedWorkshop: action.payload.data || action.payload,
        loading: false,
        error: null,
      };
    case constant.UPDATE_WORKSHOP:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case constant.CREATE_WORKSHOP:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case constant.GET_COMMUNITY_LINKS:
      return {
        ...state,
        communityLinks: Array.isArray(action.payload.data)
          ? action.payload.data
          : action.payload.data?.result || [],
        communityLinksPagination:
          action.payload.pagination || action.payload.data?.pagination || null,
        loading: false,
        error: null,
      };
    case constant.CREATE_OR_UPDATE_COMMUNITY_LINK:
      return {
        ...state,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
}; 